import { render } from "./px-matching-interest.vue?vue&type=template&id=3da22f22&scoped=true&ts=true"
import script from "./px-matching-interest.vue?vue&type=script&lang=ts"
export * from "./px-matching-interest.vue?vue&type=script&lang=ts"

import "./px-matching-interest.vue?vue&type=style&index=0&id=3da22f22&lang=scss&scoped=true"
import "./px-matching-interest.vue?vue&type=style&index=1&id=3da22f22&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da22f22"]])

export default __exports__